import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import CustomApplicationState from "@nishtech/Store/Nishtech/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface AllCategoryWithWidgetStyles {
    nishtechMenuContainer: GridContainerProps;
    nishtechMenuFirstGridItem: GridItemProps;
    nishtechMenuSecondGridItem: GridItemProps;
    nishtechMenuThirdGridItem :GridItemProps;
    megaMenuHeading: LinkPresentationProps;
    megaMenuLink: LinkPresentationProps;
    childLinkList:InjectableCss;
}

export const nishtechMenuSectionStyles: AllCategoryWithWidgetStyles = {
    nishtechMenuContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css``,
                    // css`
                    //         padding: 0px 9%;
                    //     `,
                ])}
            }
        `,
    },
    nishtechMenuFirstGridItem: {
        css: css`
            padding: 0px;
            max-width: 20%;
            flex-basis: 20%;
            flex-direction: column;
            /* border-right: 2px solid ${getColor("common.border")}; */
            overflow: hidden auto;
            > li {
                max-width: 100%;
                flex-basis: 100%;
                padding: 0px 15px 10px;
                margin-left: 5px;
                font-size: 12px;
                width: 100%;
                max-height: 28px;
            }
        `,
    },
    nishtechMenuSecondGridItem: {
        css: css`
            max-width: 80%;
            flex-basis: 80%;
            padding: 0px 15px;
            > div[class^="Wrapper"] {
                max-width: 100%;
                flex-basis: 100%;
                > div[class^="ContentWrapper"], .wrapper {
                    display: flex;
                    flex-basis: 100%;
                    max-width: 100%;
                    flex-direction: row;
                    gap: 20px;
                    padding: 0px 0px 10px;
                    > div {
                        color: ${getColor("text.main")};
                        width: calc(100% / 4);
                        img {
                            width: 100%;
                            height: 150px;
                        }
                        > div > a {
                            font-size: 12px;
                            font-weight: bold;
                            margin-top: 10px;
                            width: 100%;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                        p {
                            padding: 0;
                            font-size: 12px;
                            margin: 0;
                            font-weight: normal;
                            line-height: normal;
                        }
                        > a {
                            display: inline-block;
                            padding: 0;
                            font-size: 12px;
                            font-weight: normal;
                            line-height: normal;
                            text-transform: none;
                            text-decoration: underline;
                            text-underline-offset: 2px;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                    }
                }
            }
        `,
    },
     nishtechMenuThirdGridItem: {
        css: css`
            max-width: 80%;
            flex-basis: 80%;
            padding: 0px 15px;
            > div[class^="Wrapper"] {
                max-width: 100%;
                flex-basis: 100%;
                > div[class^="ContentWrapper"], .wrapper {
                    display: flex;
                    flex-basis: 100%;
                    max-width: 100%;
                    flex-direction: row;
                    gap: 20px;
                    padding: 0px 0px 10px;
                    > div {
                        color: ${getColor("text.main")};
                        width: calc(100% / 4);
                        img {
                            width: 100%;
                            height: 150px;
                        }
                        > div > a {
                            font-size: 12px;
                            font-weight: bold;
                            margin-top: 10px;
                            width: 100%;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                        p {
                            padding: 0;
                            font-size: 12px;
                            margin: 0;
                            font-weight: normal;
                            line-height: normal;
                        }
                        > a {
                            display: inline-block;
                            padding: 0;
                            font-size: 12px;
                            font-weight: normal;
                            line-height: normal;
                            text-transform: none;
                            text-decoration: underline;
                            text-underline-offset: 2px;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                    }
                }
            }
        `,
    },
    megaMenuHeading: {
        css: css`padding-bottom:10px;
                    border-bottom: 1px solid rgba(255 255 255);
                    border-bottom-width: 1px;
                    border-bottom-style: solid;
                    border-bottom-color: initial;
                    font-size: 16px !important;
                    font-weight: bold !important;`,
    },
    megaMenuLink: {},
    childLinkList: {
            css: css`
                     padding-top: 5px;
                    `,
        }
};

interface OwnProps {
    link: MappedLink;
    categoryId: string | undefined;
    category: MappedLink; 
    onHandleClose: Function;
    zoneId: string;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        session: state.context.session,

    };
};

const mapDispatchToProps = {
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const AllCategoryWithWidgetComponent = ({ link, onHandleClose
    // , toggleLoginDrawer, toggleRewardsDrawer, toggleDrawer
    , zoneId
    , session }: Props) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number | null>(null);
    const handleMouseEnter = (index: number, categoryName: string) => {
        setActiveChildIndex(index);
    };
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;


    const handleMouseLeave = () => {
        setActiveChildIndex(null);
    };

    useEffect(() => {
    }, []);

    useEffect(() => {
        const childLinks = document.querySelectorAll(".child-link");
        const handleLinkClick = () => {
            onHandleClose();
        };
        childLinks.forEach(link => {
            link.addEventListener("click", handleLinkClick);
        });

        return () => {
            childLinks.forEach(link => {
                link.removeEventListener("click", handleLinkClick);
            });
        };
    }, [isAuthenticated
    ]);

    const styles = nishtechMenuSectionStyles;

    return (
        <>
            <GridContainer {...styles.nishtechMenuContainer}>
                <GridItem {...styles.nishtechMenuFirstGridItem} className="parent-container" width={(link.allowMultipleWidget ? link.firstContainerWidth  ?? 4 : 12) as GridWidths}
                >
                    {link.children && (
                        <ul>
                            <StyledWrapper {...styles.childLinkList}>
                            {link.children
                                .filter(child => !child.excludeFromNavigation)
                                .map((child, index) => (
                                    <li key={index}>
                                        <Link
                                            {...styles.megaMenuLink}
                                            href={child.url}
                                        >{child.title}
                                        </Link>
                                    </li>
                                ))}
                            </StyledWrapper>
                        </ul>
                    )}
                </GridItem>
                {link.allowMultipleWidget &&(
                <><GridItem {...styles.nishtechMenuSecondGridItem} width={(link.secondContainerWidth ?? 4) as GridWidths}>
                        <Zone contentId={zoneId} zoneName="widget-1" />
                    </GridItem><GridItem {...styles.nishtechMenuThirdGridItem} width={(link.thirdContainerWidth ?? 4) as GridWidths}>
                            <Zone contentId={zoneId} zoneName="widget-2" />
                        </GridItem></>)}
            </GridContainer>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AllCategoryWithWidgetComponent);
